import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../hooks/usePageMeta";

export default function NotFoundPage() {
    usePageMeta("Page Not Found — Titan Haven Group LLC", "The requested page does not exist.", { noindex: true });
    return (
        <main className="min-h-[70vh] flex items-center" data-testid="not-found-page">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
                <Reveal>
                    <img src="/assets/thg-shield-sm.png" alt="" className="h-12 w-auto" />
                    <p className="mt-8 text-xs tracking-[0.25em] uppercase font-bold text-thg-tertiary">404</p>
                    <h1 className="mt-4 font-display text-4xl md:text-5xl font-medium text-white tracking-tight">
                        This page doesn&rsquo;t exist.
                    </h1>
                    <p className="mt-5 text-base leading-relaxed text-thg-secondary max-w-md">
                        The address may have changed. The work hasn&rsquo;t.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-4">
                        <Link
                            to="/"
                            data-testid="notfound-home"
                            className="inline-flex items-center gap-2 bg-thg-red text-white hover:bg-thg-redhover transition-colors duration-300 px-6 py-3 text-sm tracking-wide uppercase"
                        >
                            Home <ArrowRight size={16} />
                        </Link>
                        <Link
                            to="/portfolio"
                            data-testid="notfound-portfolio"
                            className="inline-flex items-center gap-2 border border-white/40 text-white hover:bg-white hover:text-black transition-colors duration-300 px-6 py-3 text-sm tracking-wide uppercase"
                        >
                            Portfolio
                        </Link>
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
